module.exports = "Molecules are a combination of atoms. They can usually be broken down into a few smaller pieces."